import { ExportRow } from '@portal/shared/types/export.types';
import type { FieldOperationsListItem } from '../ui/field-operations.types';

export const mapFieldOperationToExportRows = (
  fieldOperation: FieldOperationsListItem,
  formatDate: (date: string) => string
): ExportRow[] => {
  if (fieldOperation.childItems.length === 0) {
    return [
      {
        installationDateTime: { title: 'OperationDateTime', value: fieldOperation.installationDateTime },
        mtuDeviceLabel: { title: 'CommDeviceID', value: fieldOperation.mtuDeviceLabel },
        installationReason: { title: 'Reason', value: fieldOperation.installationReason },
        meterSerialNumber: { title: 'MeterSerialNumber', value: '' },
        meterModel: { title: 'MeterModel', value: '' },
        port: { title: 'Port', value: '' },
        serviceLocationIds: { title: 'ServiceLocationNumber', value: '' },
        wakeupDateTime: { title: 'WakeUpReceived', value: '' },
        initialReadDateTime: { title: 'ReadingReceived', value: '' },
        installedBy: { title: 'InstalledBy', value: fieldOperation.installedBy }
      }
    ];
  }

  return fieldOperation.childItems.map(childItem => ({
    installationDateTime: { title: 'OperationDateTime', value: fieldOperation.installationDateTime },
    mtuDeviceLabel: { title: 'CommDeviceID', value: fieldOperation.mtuDeviceLabel },
    installationReason: { title: 'Reason', value: fieldOperation.installationReason },
    meterSerialNumber: { title: 'MeterSerialNumber', value: childItem.serialNumber },
    meterModel: { title: 'MeterModel', value: childItem.model },
    port: { title: 'Port', value: childItem.port },
    serviceLocationIds: { title: 'ServiceLocationNumber', value: childItem.serviceLocationIds },
    wakeupDateTime: {
      title: 'WakeUpReceived',
      value: childItem.wakeupDateTimeUtc ? formatDate(childItem.wakeupDateTimeUtc) : childItem.wakeupDateTimeUtc
    },
    initialReadDateTime: {
      title: 'ReadingReceived',
      value: childItem.initialReadDateTimeUtc
        ? formatDate(childItem.initialReadDateTimeUtc)
        : childItem.initialReadDateTimeUtc
    },
    installedBy: { title: 'InstalledBy', value: fieldOperation.installedBy }
  }));
};
